// Payroll integration codes
const integrationCodes = {
  a3innuva: '148642324',
  a3nom: '146392782',
  datev: '146479883',
  datev_api: '148440300',
  datev_lug_api: '177166166',
  datev_lauds: 'aoNL4KHjS0CDRdbtSQ1RjQ',
  paierh: '149038994',
  yeap_paierh: 'VOKHWDa2SziPUTFGjMAjKw',
  silae: '146479793',
  silae_api: '155731018',
  silae_fortify: 'Y0h_Sh7pRxCWpl0DySn_uQ',
  zucchetti: '146431400',
  gispaghe: 'N1Ex7A7LRW6XpUOPloOoGA',
} as const

export type IntegrationCodesTypes = (typeof integrationCodes)[keyof typeof integrationCodes]

export default integrationCodes
